export default __webpack_public_path__ + "static/media/SEA_8424.9f4f0d3d.jpg";